import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// actions
import { updatePlayersFilter } from 'js/store/search/Search.actions';

// selectors
import { getTranslationById } from 'js/store/app/App.selectors';
import { getAvailableOptionsById } from 'js/store/search/Search.selectors';

// components
import ButtonBasic from '../button/Button.basic';

const SELECTED_COLOR = '#f7ebb1';
const UNSELECTED_COLOR = '#003764';

const PLAYER_OPTIONS = [
  { id: 'players_1', label: '1' },
  { id: 'players_2', label: '2-4' },
  { id: 'players_3', label: '5+' },
];

const FindPlayersOptions = () => {
  const dispatch = useDispatch();
  const availablePlayers = useSelector((state) => getAvailableOptionsById(state, 'players'));

  const selectedPlayers = useSelector((state) => state?.search?.filters?.players);

  const title = useSelector((state) => getTranslationById(state, 'find_step_2_players_title', 'How many players?'));

  const updateSelection = useCallback(
    (playersId) => {
      dispatch(updatePlayersFilter(playersId));
    },
    [dispatch]
  );

  const getButtonStyle = (isSelected) => ({
    backgroundColor: isSelected ? SELECTED_COLOR : 'transparent',
    border: `3px solid ${isSelected ? SELECTED_COLOR : UNSELECTED_COLOR}`,
    color: UNSELECTED_COLOR,
  });

  return (
    <>
      <h2 className="find__title find__players-title">{title}</h2>

      <ul className="find__player-options">
        {PLAYER_OPTIONS.map(({ id, label }) => {
          const isSelected = selectedPlayers.includes(id);
          const isAvailable = availablePlayers.includes(id);
          return (
            <li key={id} className={isSelected ? 'active' : '' + (isAvailable ? '' : ' disabled')}>
              <ButtonBasic
                title={label}
                action={() => {
                  isAvailable && updateSelection(id);
                }}
                style={getButtonStyle(isSelected)}
                disabled={!isAvailable}
              />
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default FindPlayersOptions;
